import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { splitProfilesService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type applicationHistoryProps = {
	historyKey: string;
	fetchData: {
		page: number;
	};
	id: number;
};

const useGetSplitProfileHistoryQuery = ({
	historyKey,
	fetchData,
	id,
}: applicationHistoryProps) => {
	const dispatch = useDispatch();

	const { page } = fetchData || {};

	return useQuery(
		[historyKey, page],
		() => splitProfilesService.getSplitProfileHistory({ page, id }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!id,
			cacheTime: 0,
		},
	);
};

export default useGetSplitProfileHistoryQuery;
